<template>
  <div>
    <!-- <cabecalho title="CONTABIL.OUTRAS_INFORMACOES" title_type="modal" /> -->

    <div class="row">
      <div class="col-12 col-md-6">
        <input-select-search
          ref="categoria"
          v-model="form.categoriaId"
          :label="$t(`CONTABIL.CATEGORIA`)"
          :options="opcoes.categorias"
          required
        />
      </div>

      <div class="col-12 col-md-6">
        <input-date-only-btn
          ref="dataMovimento"
          v-model="form.dataMovimento"
          :label="$t('CONTABIL.DATA_MOVIMENTO')"
          required
        />
      </div>

      <div class="col-12 col-md-6">
        <input-number
          ref="valor"
          v-model="valor"
          :label="$t('CONTABIL.VALOR')"
          disabled
          decimal
        />
      </div>
    </div>
  </div>
</template>
<script>
// Utils & Aux:
import mensagem from '@/common/utils/mensagem';
import { START_LOADING, STOP_LOADING } from '@/store/Store';

// Services:
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service';

//componentes
import {
  InputDateOnlyBtn,
  InputNumber,
  InputSelectSearch,
} from '@/components/inputs';
// import { Cabecalho } from '@/components/headers';
// import ContasAPagar from '../documento-origem/contas-pagar/Index.vue';
// import ContasAReceber from '../documento-origem/contas-receber/Index.vue';

export default {
  props: {
    form: { type: Object, default: Object },
    valor: { type: Number, default: 0 },
  },
  components: {
    InputDateOnlyBtn,
    InputNumber,
    InputSelectSearch,
    // Cabecalho,
    // ContasAPagar,
    // ContasAReceber,
  },
  watch: {
    'form.categoriaId': 'encontrarDescricaoCategoria',
  },
  data() {
    return {
      opcoes: {
        categorias: [],
        // tiposTitulo: [
        //   { text: 'Contas a pagar', value: '0' },
        //   { text: 'Contas a receber', value: '1' },
        // ],
      },
      // filtro: {
      //   exibir: false,
      // },
    };
  },
  mounted() {
    this.getCategorias();
    this.$emit('refs', this.$refs);
  },
  methods: {
    getCategorias() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('categoria-documento-contabil')
        .then(({ data }) => {
          data = data.map((row) => ({
            value: row.id,
            text: row.descricao,
          }));
          this.opcoes.categorias = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    encontrarDescricaoCategoria() {
      if (!this.form.categoriaId) return;
      this.opcoes.categorias.forEach((element) => {
        element.id == this.form.categoriaId
          ? (this.form.categoria = element.id)
          : {};
      });
    },
    // funções modal
    abrirFecharForm() {
      this.filtro.exibir == false
        ? (this.filtro.exibir = true)
        : (this.filtro.exibir = false);
    },
  },
};
</script>
